import React from "react";

import { Button } from "rhombus-react";

import { noop } from "utils/common";
import { MAX_VERSION_GEN_CREATIVES } from "utils/constants";

import EmptySection from "widgets/EmptySection";

export default function TooManyCreatives(props){
	const {
		onClose = noop,
	} = props;

	const sectionProps = {
		header: `Maximum of ${MAX_VERSION_GEN_CREATIVES} creatives exceeded!`,
		src: "/images/noFiles.svg",
		message: `You can only generate versions for up to ${MAX_VERSION_GEN_CREATIVES} creatives at a time`,
		buttons: <Button onClick={onClose}>{`Back to Creative List`}</Button>,
	};

	return <EmptySection {...sectionProps} />;
}

TooManyCreatives.displayName = "TooManyCreatives";
